import { render } from "./MGToggle.vue?vue&type=template&id=64038404&scoped=true"
import script from "./MGToggle.vue?vue&type=script&lang=js"
export * from "./MGToggle.vue?vue&type=script&lang=js"

import "./MGToggle.vue?vue&type=style&index=0&id=64038404&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64038404"]])

export default __exports__